import CloseIcon from "@mui/icons-material/Close";
import "./FileAttachments.scss";
import { Dialog } from "@mui/material";
import FileAttachmentsDetails from "./FileAttachmentsDetails";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { checkPermissions } from "../../helper";
import { EMISSION_DATA_STATUS_TYPE } from "../../constants/enums";
const FileAttachments = (props: any) => {
  const {
    setShowAttachment,
    formData,
    setFormData,
    cellColumns,
    sourceAttachmentData,
    setSourceAttachmentData,
    emissionLogAttachmentData,
    setEmissionLogAttachmentData,
    saveAttachments,
    fromEmissionDetail,
    editAttachments,
    emissionAttachmentData,
    setEmissionAttachmentData,
    setEditAttachmentsData,
    fromEmissionDetailParent,
    emissionStatus,
  } = props;
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const handleSave = () => {
    if (emissionLogAttachmentData?.attachments?.length >= 0) {
      editAttachments(emissionLogAttachmentData, "emissionLog");
    } else if (emissionAttachmentData?.attachments?.length >= 0) {
      editAttachments(emissionAttachmentData, "emission");
    } else {
      saveAttachments(sourceAttachmentData);
    }
    if (fromEmissionDetailParent) {
      setEditAttachmentsData(false);
    } else {
      setShowAttachment(false);
    }
  };
  const handleClose = () => {
    if (fromEmissionDetailParent) {
      setEditAttachmentsData(false);
    } else {
      setShowAttachment(false);
    }
  };
  return (
    <Fragment>
      <div className="pw-file-attachement-container">
        <Dialog className="pw-dialog-container-test" open={true}>
          <div className="pw-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">
                {" "}
                {fromEmissionDetail ? "Edit" : "Add"} attachments
              </div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={handleClose}
                />
              </div>
            </div>
            {cellColumns?.length && (
              <div className="w-full mt-5">
                <Table
                  aria-label="simple table"
                  className="pw-attachements-table"
                >
                  <TableHead className="bg-netural-50">
                    <TableRow className="bg-neutral-50">
                      <TableCell className=" !text-neutral-600">
                        {cellColumns[0]}
                      </TableCell>
                      <TableCell
                        align="right"
                        className=" !text-neutral-600 pw-min-width-5rem"
                      >
                        {cellColumns[1]}
                      </TableCell>

                      <TableCell
                        align="left"
                        className="pw-width-5rem"
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow className="bg-neutral-50">
                      <TableCell className="pw-row pw-major-row !text-neutral-900">
                        <div className="pw-emission-label">
                          {sourceAttachmentData?.label ??
                            sourceAttachmentData?.emissionsourcename ??
                            emissionLogAttachmentData?.sourceDetail
                              ?.sourceValue}
                        </div>
                        {sourceAttachmentData?.engine_name ||
                        emissionLogAttachmentData?.sourceDetail?.engine_name ? (
                          <div className="text-neutral-600 text-xs">
                            {sourceAttachmentData?.engine_name ??
                              emissionLogAttachmentData?.sourceDetail
                                ?.engine_name}
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        align="right"
                        className=" !text-neutral-600 pw-min-width-5rem"
                      >
                        {sourceAttachmentData?.units ??
                          emissionLogAttachmentData?.sourceDetail?.total}
                      </TableCell>

                      <TableCell
                        align="left"
                        className="pw-width-5rem"
                      ></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            )}
            <FileAttachmentsDetails
              sourceAttachmentData={sourceAttachmentData}
              setSourceAttachmentData={setSourceAttachmentData}
              formData={formData}
              setFormData={setFormData}
              emissionLogAttachmentData={emissionLogAttachmentData}
              setEmissionLogAttachmentData={setEmissionLogAttachmentData}
              emissionAttachmentData={emissionAttachmentData}
              setEmissionAttachmentData={setEmissionAttachmentData}
              emissionStatus={emissionStatus}
            />
          </div>
          {(emissionStatus === EMISSION_DATA_STATUS_TYPE.APPROVED
            ? checkPermissions(["UPDATE_APPROVED_EMISSIONS"], permissions)
            : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
          emissionStatus !== EMISSION_DATA_STATUS_TYPE.REJECTED ? (
            <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6 mt-5">
              <div
                onClick={handleClose}
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
              >
                Cancel
              </div>
              <div
                onClick={handleSave}
                className={`pw-bunit-button-primary pw-bunit-button-save text-white
      ${"cursor-pointer bg-primary"}`}
              >
                Save
              </div>
            </div>
          ) : (
            <div className="p-4"></div>
          )}
        </Dialog>
      </div>
    </Fragment>
  );
};
export default FileAttachments;
